import {METADATA} from "./constants";

export const allSafetyPackageGroups = [
  "shower_seats", "shower_arm", "shower_pan_combo", "hand_shower_kit",
  "handle_shower_valve", "l_shaped_grab_bar", "shower_head", "seat_pad", "valve_trim", "diverter_trim"
];

export const safetyPackageSameSideGroups = {
  "5": ["shower_pan_combo", "shower_arm", "shower_head", "l_shaped_grab_bar", "valve_trim"],
  "6": ["shower_pan_combo", "shower_arm", "shower_head", "l_shaped_grab_bar"],
};

export const updateFeatureGroupsWithNewSide = (clickedFeature, newPosition) => {
  if (!allSafetyPackageGroups.includes(clickedFeature.partId)) {
    return
  }
  const layout = clickedFeature.getParent().getParent().layout;
  allSafetyPackageGroups.forEach(partId => {
    const featureGroup = layout.getFeatureGroupByPartId(partId);
    if (!featureGroup
      || (featureGroup.partId === "shower_pan_combo"
        && featureGroup.activeFeature?.dbFeature?.metaData?.layerPosition === "C")) {
      return
    }
    const newGroupSide = getSafetyPackageSide(featureGroup, newPosition, clickedFeature.partId);
    if (featureGroup.layerPositions) {
      Object.keys(featureGroup.layerPositions).forEach(key => {
        if (key === newGroupSide) {
          const newFeature = featureGroup.getMatchingPositionFeature(newGroupSide);
          featureGroup.layerPositions[key] = newFeature || null;
          if (newFeature) {
            featureGroup.activeFeature = newFeature;
          }
        } else {
          featureGroup.layerPositions[key] = null;
        }
      })
    } else if (featureGroup.oneLayerPosition) {
      featureGroup.activeFeature = featureGroup.getMatchingPositionFeature(newGroupSide) || null;
    }
  })
}

export const getSafetyPackageSide = (featureGroup, newPosition, fromPartId) => {
  const fromInGroup = safetyPackageSameSideGroups[document.kvConfig.toolVersion || 5]?.includes(fromPartId);
  const featureInGroup = safetyPackageSameSideGroups[document.kvConfig.toolVersion || 5]?.includes(featureGroup.partId);
  const isOpposite = fromInGroup !== featureInGroup; // XOR
  if (isOpposite) {
    return newPosition === METADATA.RightSide ? METADATA.LeftSide : METADATA.RightSide;
  }
  return newPosition;
};

export const shouldUseSafetyPackage = (featureGroup) => {
  const layout = featureGroup.getParent().layout;
  const showerAccParent = layout.parts["Shower Accessories"];
  const showerParent = layout.parts["Shower"];
  if (showerParent?.showerTubComboIsActive()) {
    return false
  }
  if (showerAccParent?.lShapedGrabBar?.activeFeature?.dbFeature?.metaData?.layerPosition
    && !showerAccParent.lShapedGrabBar.disabled) {
    return true
  }
  return document.kvConfig.toolVersion === 5
    ? (showerAccParent?.handShowerKit?.activeFeature?.dbFeature?.metaData?.layerPosition && !showerAccParent.handShowerKit.disabled)
    : (showerParent?.handShowerKit?.activeFeature?.dbFeature?.metaData?.layerPosition && !showerParent.handShowerKit.disabled)
}


// export const getSafetyPackageSide = (featureGroup) => {
//   const layout = this.getParent().layout;
//   const showerAccParent = layout.parts["Shower Accessories"];
//   const showerParent = layout.parts["Shower"];
//   if (showerParent?.showerTubComboIsActive()
//     || !showerAccParent?.handShowerKit?.activeFeature?.dbFeature?.metaData?.layerPosition) {
//     return "NO"
//   }
//   switch (featureGroup.partId) {
//     case "shower_arm":
//     case "shower_head":
//     case "l_shaped_grab_bar":
//       return showerAccParent.handShowerKit.activeFeature.dbFeature.metaData.layerPosition // same side
//     default:
//       return showerAccParent.handShowerKit.activeFeature.dbFeature.metaData.layerPosition === METADATA.RightSide
//         ? METADATA.LeftSide
//         : METADATA.RightSide; // opposite side
//   }
// }
